import * as React from "react"

const _ShirtPolo = ({
  color,
  lightColor
}: {
  color: string
  lightColor: string
  isEditor?: boolean
}) => {
  return (
    <svg
      style={{
        position: "absolute",
        bottom: "-2%",
        width: "98%",
        height: "26%",
        left: "-0.2%"
      }}
      width="281"
      height="93"
      viewBox="0 0 281 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M142.771 67.5777C142.771 67.5779 142.771 67.5779 144 66L142.771 67.5779L144.493 68.9188L145.679 67.0874L145.679 67.087L145.681 67.0841L145.69 67.0697L145.731 67.0072C145.742 66.9904 145.755 66.971 145.769 66.9491C145.803 66.8975 145.847 66.8318 145.9 66.7529C146.05 66.5278 146.275 66.1947 146.57 65.7695C147.158 64.919 148.023 63.7016 149.118 62.2463C151.312 59.3316 154.416 55.482 158.071 51.7183C161.737 47.9446 165.898 44.3176 170.198 41.7935C174.514 39.2597 178.777 37.9491 182.733 38.4825C225.171 44.2046 256.402 63.002 276.674 91.0006H3.37453C19.6742 61.6588 42.8579 42.9825 80.4446 34.4127C82.0464 34.0474 84.2242 34.1581 86.9471 34.7915C89.6421 35.4183 92.7146 36.5194 96.0282 37.9759C102.655 40.8887 110.052 45.1363 117.004 49.5364C123.945 53.9299 130.39 58.4425 135.104 61.8597C137.459 63.5674 139.379 64.9995 140.709 66.0036C141.374 66.5056 141.891 66.9005 142.241 67.1693C142.416 67.3037 142.55 67.4065 142.639 67.4754L142.739 67.553L142.764 67.5722L142.77 67.5767L142.771 67.5777Z"
        fill={color}
        stroke="black"
        strokeWidth="4"
      />
      <path
        d="M68.6127 37.0849L73.7794 17.8529C73.9886 17.0741 74.9962 16.854 75.5402 17.4493C90.4034 33.7135 109.16 33.0762 115.385 32.3297C116.23 32.2284 116.892 33.1531 116.495 33.906L103.338 58.859C103.136 59.2414 102.724 59.4518 102.3 59.3636C98.3518 58.5411 78.6774 53.7321 68.7286 37.8667C68.583 37.6345 68.5416 37.3496 68.6127 37.0849Z"
        fill={lightColor}
        stroke="black"
        strokeWidth="4"
      />
      <path
        d="M199.195 36.9814L187.615 17.4989C187.222 16.8374 186.253 16.8483 185.834 17.4937C180.097 26.3296 170.202 30.4 166.742 31.6024C166.12 31.8187 165.835 32.5584 166.171 33.1254L179.673 55.9402C179.875 56.2806 180.255 56.4651 180.636 56.3568C182.771 55.749 190.096 52.6851 199.182 38.0212C199.378 37.706 199.385 37.3001 199.195 36.9814Z"
        fill={lightColor}
        stroke="black"
        strokeWidth="4"
      />
      <path
        d="M125.5 54.5L116.5 33L109.5 48L125.5 54.5Z"
        fill="black"
        stroke="black"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M157 53.5L166 32L173 47L157 53.5Z"
        fill="black"
        stroke="black"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M86.5 14L74.5 17L84.5 23.5L86.5 14Z"
        fill="black"
        stroke="black"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M176 14L187 17L180 23.5L176 14Z"
        fill="black"
        stroke="black"
        strokeWidth="4"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ShirtPolo = React.memo(_ShirtPolo)
